import axios from "axios";
import Vue from "vue";
import settings from "../settings";

export const client = axios.create({
  baseURL: settings.address + "/api/",
  headers: {
    "Access-Control-Allow-Origin": "*"
  }
})

export const errorHandler = function (err, context, then, text) {
  if (!then) {
    then = function () {}
  }
  if (err.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.log(err.response.data);
    console.log(err.response.status);
    console.log(err.response.headers);
    if (!text) {
      text = "Ошибка валидации"
    }
    if (err.response.data.detail) {
      if (typeof err.response.data.detail == "string") {
        text = err.response.data.detail
      }
    }
    if (err.response.status == 401 || err.response.status == 403 || err.response.status == 409) {
      then = function () {
        Vue.$cookies.remove("token");
        window.location.href = settings.auth_url;
      };
      context.$swal({
        "icon": "error",
        "text": text,
        confirmButtonText: "Перейти",
      }).then(then);
      return
    }
    context.$swal({
      "icon": "error",
      "text": text,
    }).then(then)
  } else if (err.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(err.request);
    context.$swal({
      "icon": "error",
      "text": "Проблемы на стороне сервера. Мы скоро всё починим!",
    }).then(then)
  } else {
    // Something happened in setting up the request that triggered an Error
    context.$swal({
      "icon": "error",
      "text": "Упс, непредвиденная поломка. Мы скоро всё починим!",
    }).then(then)
  }
  // console.log(err.config);
}
